<template>
    <div class="home container mt-5 pt-5">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <img :src="base_url + '/files/images/ph04.png'" class="displaypc" style="width: 100%;">
                <img :src="base_url + '/files/images/ph04m.png'" class="displaymb" style="width: 100%;">
                <div class="container mt-5" :style="contentStyle">
                    <div class="row" style="justify-content: space-evenly;">
                        <a :href="base_url + '/category-new/' + item.name" class="homebtn col-lg-4 mt-2 text-center"
                            v-for="(item, index) in activeCategories" :key="index">
                            <span
                                :style="`background: url('${base_url}/uploads/${item.image}'); background-repeat: no-repeat; background-position: center;`">
                                {{ item.image ? "" : item.name }}
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            base_url,
            categories: [],
        }
    },
    created() {
        axios
            .get(base_url + '/api/category/' + '0')
            .then((response) => {
                this.categories = response.data.children;
                this.contentStyle();
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    computed: {
        activeCategories: function () {
            return this.categories.filter(category => category.state)
        },
    },
    methods: {
        contentStyle() {
            if (this.categories.filter(category => category.state).length && this.categories.length) return {};
            else return {
                background: `url('${base_url}/files/images/empty-category-new.png')`,
                "background-repeat": "no-repeat",
                height: '69px',
                width: '253px'
            };
        }
    },
}
</script>

<style scoped>
.homebtn span {
    display: block;
    width: 300px;
    height: 60px;
}

.homebtn {
    display: block;
    width: 300px;
    height: 60px;
}

.home {
    min-height: 680px;
}

/* #listbtn1 {
    background-image: url(/files/images/listbtn1.png);
}

#listbtn1:hover {
    background-color: rgb(224, 224, 224);
    background-image: url(/files/images/listbtn1hr.png);
}

#listbtn2 {
    background-image: url(/files/images/listbtn2.png);
}

#listbtn2:hover {
    background-color: rgb(224, 224, 224);
    background-image: url(/files/images/listbtn2hr.png);
}

#listbtn3 {
    background-image: url(/files/images/listbtn3.png);
}

#listbtn3:hover {
    background-color: rgb(224, 224, 224);
    background-image: url(/files/images/listbtn3hr.png);
} */

@media only screen and (max-width: 991px) {
    .displaypc {
        display: none;
    }
}

@media only screen and (min-width: 992px) {
    .displaymb {
        display: none;
    }
}
</style>
